module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-regular-400.4776aa52.woff";